import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import moment from "moment";

import { MediaCommentContainer } from "../styled/common";

import { FiSend } from "react-icons/fi";
import { BsChevronRight } from "react-icons/bs";
import { MdDelete } from "react-icons/md";
import { IoMdClose } from "react-icons/io";

const MediaComment = ({
  toggleComment,
  openComment,
  comments = [],
  handleComment,
  comment,
  setComment,
  isMobile = false,
}) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const location = useLocation();

  const isShareReportPage = location.pathname.includes("share-report");

  const sameMember = (item) => {
    return user && item && String(user.mberNo) === item.createMberId;
  };

  const formatCreateDt = (createDt) => {
    if (!Array.isArray(createDt) || createDt.length < 6) return "";

    const [year, month, day, hour, minute, second] = createDt;
    return moment({ year, month: month - 1, day, hour, minute, second }).format("YY.MM.DD HH:mm");
  };

  return (
    <MediaCommentContainer className={openComment ? "open" : "close"}>
      <div className="info">
        {/* 모바일에서는 슬라이드 화살표 숨김 (인스타처럼 아래 고정) */}
        {!isMobile && (
          <button onClick={toggleComment}>
            <BsChevronRight />
          </button>
        )}
      </div>
      <ul className="comments">
        {comments.length > 0 ? (
          comments.map((item) => (
            <li key={item.photoReviewNo || item.id}>
              <div className={sameMember(item) ? "writer" : ""}>
                <strong>{item.mberNm}</strong>
                <p>{item.comment}</p>
                <span>{formatCreateDt(item.createDt)}</span>
              </div>
              {sameMember(item) && !isShareReportPage && (
                <button onClick={() => handleComment(item, true)}>
                  <IoMdClose />
                </button>
              )}
            </li>
          ))
        ) : (
          <li className="not">댓글이 존재하지 않습니다.</li>
        )}
      </ul>
      {user && !isShareReportPage && (
        <div className="form">
          <input
            type="text"
            placeholder="댓글을 입력해주세요"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            onKeyDown={(e) => handleEnterKey(e, () => handleComment())}
          />
          <button onClick={() => handleComment()}>
            <FiSend />
          </button>
        </div>
      )}
    </MediaCommentContainer>
  );
};

export default MediaComment;
